module.exports = __webpack_public_path__ + "img/sprinkle-15.e37a4b1c.jpg";